import React from 'react';

import { Skeleton } from '@repo/ui/components/ui/skeleton';

export const ArticlesSectionSkeleton: React.FC = () => {
  return (
    <div className="space-y-2 pt-3">
      <div className="flex w-full justify-center gap-[.9rem]">
        <Skeleton className="h-6.75 w-20 shrink-0 rounded-md bg-[#727D90]" />
        <Skeleton className="h-6.75 w-20 shrink-0 rounded-md bg-[#727D90]" />
        <Skeleton className="h-6.75 w-20 shrink-0 rounded-md bg-[#727D90]" />
        <Skeleton className="h-6.75 w-20 shrink-0 rounded-md bg-[#727D90]" />
      </div>
      <div className="flex w-full flex-col items-center justify-center px-3">
        <Skeleton className="h-6.75 w-full rounded-md bg-[#727D90]" />
      </div>
      <div className="flex h-26 w-full items-center bg-cta/30 py-5">
        <div className="w-full overflow-hidden">
          <div className="flex -translate-x-43.75 items-center">
            <div className="min-w-0 shrink-0 grow-0 basis-53.75 pl-2.5">
              <Skeleton className="h-22.5 scale-x-90 scale-y-75 bg-[#4A5568]" />
            </div>
            <div className="min-w-0 shrink-0 grow-0 basis-53.75 pl-2.5">
              <Skeleton className="h-22.5 bg-[#4A5568]" />
            </div>
            <div className="min-w-0 shrink-0 grow-0 basis-53.75 pl-2.5">
              <Skeleton className="h-22.5 scale-x-90 scale-y-75 bg-[#4A5568]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
